<template>
  <section>
    <h5 class="mb-4">Verify Mobile Number</h5>
    <p>
      Please enter the 4-digit verification code sent to your mobile number: +63
      <span class="apply-letter-spacing">{{
        customerUpdateMobileNumber.new_mobile_number
      }}</span>
    </p>
    <b-row>
      <b-col md="6">
        <b-form @submit.prevent="proceedVerifyOtp" autocomplete="off">
          <b-form-group
            label="OTP"
            :state="isValid('pin')"
            :invalid-feedback="getError('pin')"
          >
            <input
              id="pin"
              ref="pin"
              v-model="pin"
              maxlength="4"
              type="text"
              pattern="[0-9]*"
              inputmode="numeric"
            />
            <div
              v-if="hasError('message')"
              class="invalid-feedback d-block mb-3"
            >
              <i
                class="bi bi-exclamation-circle text-danger mr-1"
                aria-hidden="true"
              ></i>
              {{ getError("message") }}
            </div>
            <div
              v-if="hasError('pin')"
              class="invalid-feedback d-block mb-3"
            >
              <i
                class="bi bi-exclamation-circle text-danger mr-1"
                aria-hidden="true"
              ></i>
              {{ getError("pin") }}
            </div>
          </b-form-group>
          <b-form-group>
            <b-button
              variant="primary"
              class="border-0 px-4"
              pill
              type="submit"
              :style="{
                'background-color':
                  webDesign && webDesign.design
                    ? webDesign.design.main_color
                    : null,
                color:
                  webDesign && webDesign.design
                    ? webDesign.design.button_text_color
                    : null,
              }"
              :disabled="!pin || loading || isDisabledVerifyBtn"
            >
              Verify
            </b-button>
          </b-form-group>
          <b-form-group>
            <b-button
              variant="outline-primary"
              class="bg-transparent p-0 border-0"
              @click="handleResendPin"
              :style="{
                color:
                  webDesign && webDesign.design
                    ? webDesign.design.main_color
                    : null,
              }"
              :disabled="isDisabledSendOTP || loading || isDisabledVerifyBtn"
            >
              Resend OTP
              <span v-if="isDisabledSendOTP">in {{ sendOTPTimeLeft }}</span>
            </b-button>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </section>
</template>

<script>
const countdown = require("countdown-js");

import { mapActions, mapState, mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "ChangeMobileOTP",
  props: ["customerUpdateMobileNumber", "webDesign"],
  data() {
    return {
      pin: "",
      isDisabledSendOTP: false,
      sendOTPTimeLeft: "",
      thirtySeconds: 30000,
      oneHour: 3600000,
      pinLength: 4,
      isDisabledVerifyBtn: false,
      countdownInterval: null
    };
  },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
    }),
    ...mapState("merchant", {
      customerPortalToken: (state) => state.customerPortalToken,
    }),
    ...mapState("customer", {
      errors: (state) => state.errors,
      loading: (state) => state.loading,
      verifyOtpToken: (state) => state.verifyOtpToken,
      otp: (state) => state.otp,
    }),
    isInvalidPinLength() {
      return this.pin.length < this.pinLength;
    },
  },
  created() {
    this.$recaptchaInstance.showBadge();
    this.$nextTick(() => {
      this.$refs.pin.focus();
    });
  },
  beforeDestroy() {
    this.setErrors(null);
    this.$recaptchaInstance.hideBadge();
  },
  methods: {
    ...mapActions({
      sendCustomerNewNumberOtp: "customer/sendCustomerNewNumberOtp",
      verifyOtp: "customer/verifyOtp",
      updateCustomerMobileNumber: "customer/updateCustomerMobileNumber",
    }),
    ...mapMutations({
      setErrors: "customer/SET_ERRORS",
    }),
    async proceedVerifyOtp() {
      const recaptchaToken = await this.$recaptcha("verify_otp");

      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          pin: this.pin,
          mobile_number: this.customerUpdateMobileNumber.new_mobile_number,
          "g-recaptcha-response": recaptchaToken,
        },
      };

      await this.verifyOtp(request);

      if (!this.errors || Object.keys(this.errors).length === 0) {
        this.handleUpdateCustomerMobileNumber();
      } else {
        this.initializeSendOTPTimer();
      }
    },
    async handleResendPin() {
      const request = {
        header: {
          "X-Merchant-Token": this.customerPortalToken,
        },
        payload: {
          mobile_number: this.customerUpdateMobileNumber.new_mobile_number,
          action: "UPDATE_MOBILE_NUMBER",
        },
      };
      await this.sendCustomerNewNumberOtp(request);

      this.initializeSendOTPTimer(true);
    },
    async handleUpdateCustomerMobileNumber() {
      const request = {
        header: {
          Authorization: this.token,
          "X-Merchant-Token": this.customerPortalToken,
          "X-OTP-Token": this.verifyOtpToken,
        },
        payload: {
          current_mobile_number:
            this.customerUpdateMobileNumber.current_mobile_number,
          new_mobile_number: this.customerUpdateMobileNumber.new_mobile_number,
          confirm_mobile_number:
            this.customerUpdateMobileNumber.confirm_mobile_number,
          channel: "web",
          otp: this.otp,
        },
      };

      const response = await this.updateCustomerMobileNumber(request);

      if (!this.errors || !Object.keys(this.errors).length)
        this.handleSuccessModal(response.message);
      else this.handleModalError();
    },
    handleSuccessModal(msg) {
      this.$emit("set-change-mobile-modal-message", msg, true);
      this.$bvModal.show("change-mobile-number-generic-modal");
    },
    handleModalError() {
      if ("message" in this.errors) {
        this.$emit("set-change-mobile-modal-message", this.errors["message"]);
        this.$bvModal.show("change-mobile-number-generic-modal");
      }
    },
    isValid(field) {
      if (this.errors == null) {
        return false;
      }
      return this.errors[field] ? false : true;
    },
    getError(field) {
      if (!this.errors) return "";

      const errorField = this.errors.errors[field];

      return Array.isArray(errorField) ? errorField[0] : errorField;
    },
    hasError(field) {
      if (!this.errors) return false;

      return Boolean(this.errors.errors[field]);
    },
    initializeSendOTPTimer(isResend=false) {
      const currentTime = this.hasError("current_time")
        ? moment(this.getError("current_time").date)
        : false;
      const updatedAt = this.hasError("updated_at")
        ? moment(this.getError("updated_at").date)
        : false;
      const duration =
        currentTime !== false && updatedAt !== false
          ? moment.duration(currentTime.diff(updatedAt))
          : false;
      const hasInvalidAttempts =
        this.hasError("message") &&
        this.getError("message").includes("60 mins")
        || (this.hasError("pin")
        && ((Array.isArray(this.errors.errors['pin'])
          && this.errors.errors['pin'].filter(msg => msg.includes("60 mins")))
          || this.errors.errors['pin'].includes("60 mins")));

      const hasIntervalAttempt = 
        (this.hasError("message") &&
        this.getError("message").includes("30 seconds"))
        || (this.hasError("pin")
        && ((Array.isArray(this.errors.errors['pin'])
          && this.errors.errors['pin'].filter(msg => msg.includes("30 seconds")))
          || this.errors.errors['pin'].includes("30 seconds")));

      if (this.errors && !hasInvalidAttempts && !hasIntervalAttempt) return;

      let time =
        duration !== false ? (this.thirtySeconds - duration.asMilliseconds()) : this.thirtySeconds;

      if (hasInvalidAttempts) {
        time =
          duration !== false ? (this.oneHour - duration.asMilliseconds()) : this.oneHour;
        if(!isResend) this.isDisabledVerifyBtn = true;
        if(this.countdownInterval) this.countdownInterval.abort();
      }

      this.isDisabledSendOTP = true;
      
      this.countdownInterval = countdown.timer(
        new Date(new Date().getTime() + time),
        (timeLeft) => {
          if (timeLeft.hours === 1) {
            this.sendOTPTimeLeft = `${timeLeft.hours} hour`;
          } else if (timeLeft.hours === 0 && timeLeft.minutes < 1) {
            this.sendOTPTimeLeft = `${timeLeft.seconds} second${
              timeLeft.seconds > 1 ? "s" : ""
            }`;
          } else {
            this.sendOTPTimeLeft = `${timeLeft.minutes} minute${
              timeLeft.minutes > 1 ? "s" : ""
            } ${timeLeft.seconds} second${timeLeft.seconds > 1 ? "s" : ""}`;
          }
        },
        () => {
          this.isDisabledSendOTP = false;
          if (hasInvalidAttempts) this.isDisabledVerifyBtn = false;
          this.countdownInterval = null;
        }
      );
    },
  },
  watch: {
    pin(pin) {
      this.pin = pin.replace(/\D/g, "");
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/views/profile/_change.mobile";
</style>
